import { render, staticRenderFns } from "./RemoveRecruiter.vue?vue&type=template&id=52b336c4&"
import script from "./RemoveRecruiter.vue?vue&type=script&lang=js&"
export * from "./RemoveRecruiter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports